var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-area"},[_c('div',{staticClass:"mid"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/TERMVET-logo-white.svg"),"alt":"TermVET","width":"200"}})]),_c('h4',[_vm._v("Loading...")])])])
}]

export { render, staticRenderFns }